export default "__VITE_ASSET__DbFp14i2__"